import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  isInstructor: Yup.boolean(),
  categoryId: Yup.string().when("isInstructor", {
    is: true,
    then: Yup.string().required("Category is required for instructor"),
  }),
  description: Yup.string()
    .required("You need to write some descriptions about yourself")
    .max(500, "Your biography should not have more than 500 characters."),
});
export const initialValues = {
  isInstructor: true,
  categoryId: "",
  description: "",
};
